//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _attachment from './attachment';
export const attachment = _attachment;
export default {attachment};

